export default __webpack_public_path__ + "static/media/svg-5.035ebdf9.svg";